app.service('newBasketServiceReminder', function (basketAnalytics, loading, modal, log, html, pageConfig,
	broker, front, ajaxOrder) {

	let config, modalContent;
	let $self, $form, $actionInput, $serviceInput;

	function open() {
		if (!modalContent) {
			modalContent = $('#service-to-add-reminder-new').html();
			$('#service-to-add-reminder-new').remove();
			modal.generate({
				id: 'modal-service-to-add-reminder',
				content: modalContent,
				modifier: 'remodal-right new-services-list',
				callbackOpen: function () {
					setElements();
					setEvents();
				}
			});
		} else {
			modal.open('modal-service-to-add-reminder');
		}
	}
	function destroyModalServiceReminder() {
		modalContent = false;
		modal.destroy('service-to-add-reminder');
	}
	function submit() {
		loading.start();
		modal.close();
		if (testAB.getVar('ajax-order2') === 'B' && front.getParam('ajaxOrder')) {
			ajaxOrder.setForm($form);
		}
		$form.submit();
	}
	function logToCartEvent(servicesEventArray) {
		if (servicesEventArray.length) {
			servicesEventArray.forEach(function (service) {
				basketAnalytics.addService({
					productPlu: service.productPlu,
					servicePlu: service.servicePlu,
					details: 'services_box',
					quantity: service.quantity / 1
				});
			})
		}
	}
	function addServices() {
		var checkedServices = [];
		var logEventServicesData = [];
		$('.js-service-item', $form).each(function () {
			const $checkbox = $(this).find('input:checkbox:checked');
			if ($checkbox.length) {
				const quantity = $(this).find('.js-service-quantity').val();
				const product = $(this).data('product');
				const service = $(this).data('service');
				logEventServicesData.push({
					productPlu: $(this).data('product-plu'),
					servicePlu: $checkbox.data('plu'),
					quantity: $checkbox.data('quantity')
				})
				checkedServices.push(product + '|' + service + '|' + quantity);
			}
		});
		if (checkedServices.length) {
			$actionInput.val('ADD_SELECTED_SERVICES');
			$serviceInput.val(checkedServices.join(','));
			logToCartEvent(logEventServicesData);
			submit();
		} else {
			skip();
		}
	}
	function skip() {
		$actionInput.val('REMOVE_SELECTED_SERVICES');
		submit();
	}

	function setElements() {
		config = pageConfig.getData('order');
		$self = $('#modal-service-to-add-reminder');
		$form = $('form', $self);
		$form.attr('action', config.deliveryMode ? '/cart-delivery.bhtml' : '/cart.bhtml');
		$actionInput = $('#action', $form);
		$serviceInput = $('#services', $form);

	}
	function setEvents() {
		$('.js-add-services', $self).on('click', function () {
			addServices();
		});
		$('.js-skip', $self).on('click', function () {
			skip();
		});
	}
	let isOneInit = false;
	function init() {
		if (!isOneInit) {
			isOneInit = true;
			broker.on('REFRESH_BASKET_VIEW', function () {
				destroyModalServiceReminder();
			});
			broker.on('REMOVE_ALL_MODALS', function () {
				destroyModalServiceReminder();
			});
		}
	}

	return {
		init,
		open
	};
});
